import React, { useState } from "react";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import { IconButton } from "@mui/material";
import {checkIfDataPointLabelIsUnique} from "../../../../../../../features/salescodeStudio/mandatoryConfigs/manageKPIReview/manageKpiReviewServices";
interface DataPointInputProps {
  fieldLabel: string;
  kpi: Record<string, any>;
  key: number;
  datapoint: any;
  updateUserConfig: (_id: string, _kpi: Record<string, any>) => void;
  removeDataPoint: (_id: string) => void;
  isRemovableDataPoint: boolean;
  inputDataValidation: { minLength: number; maxLength: number };
}

const DataPointInput: React.FC<DataPointInputProps> = ({
  kpi,
  datapoint,
  updateUserConfig,
  fieldLabel,
  removeDataPoint,
  isRemovableDataPoint,
  inputDataValidation,
}) => {
  const [inputValue, setInputValue] = useState<string>(datapoint.label || "");
  const getErrorMessage = (input: string): string => {
    if (input.length < inputDataValidation.minLength) {
      return `Label must be at least ${inputDataValidation.minLength} characters.`;
    }
    //  else if (input.length > inputDataValidation.maxLength) {
    //   return `Label cannot exceed ${inputDataValidation.maxLength} characters.`;
    // } 
    
    else if(!checkIfDataPointLabelIsUnique(kpi,datapoint.id,input)) {
      return  "Label must be unique";
    }
    else {
      return "";
    }
  };
  const [errorMessage, setErrorMessage] = useState<string>(
    getErrorMessage(datapoint.label || "")
  );

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newLabel = e.target.value;
    if(newLabel.length <= inputDataValidation.maxLength)
    {setErrorMessage(getErrorMessage(newLabel));
    setInputValue(newLabel);
    updateDataPointLabel(newLabel);}
  };

  const updateDataPointLabel = (newLabel: string) => {
    let newDataPoints;

    const existingDataPoint = kpi.data_points.find(
      (dp: Record<string, any>) => dp.id === datapoint.id
    );

    if (existingDataPoint) {
      // Update the label if the data point exists
      newDataPoints = kpi.data_points.map((dp: Record<string, any>) =>
        dp.id === datapoint.id ? { ...dp, label: newLabel } : dp
      );
    } else {
      // Add a new data point with default values and overwrite the label
      const defaultDataPoint = { ...datapoint, label: newLabel };
      newDataPoints = [...kpi.data_points, defaultDataPoint];
    }

    const newKpi = {
      ...kpi,
      data_points: newDataPoints,
    };

    updateUserConfig(kpi.id, newKpi);
  };
    return (
    <div className="kpi-input-wrapper" >
      <label className="kpi-saved-label">{fieldLabel}</label>
      <div  style={{display:isRemovableDataPoint?"flex":undefined,}} >
      <div className="kpi-input-box-and-error-container">
        <input
          className="kpi-input-box"
          type="text"
          value={inputValue}
          onChange={handleInputChange}
        />
        {errorMessage && (
          <div className="kpi-error-message">{errorMessage}</div>
        )}
      </div>
      {isRemovableDataPoint && (
        <div style={{ marginTop: "3px" }}>
          <IconButton
            aria-label="delete"
            size="small"
            onClick={() => removeDataPoint(datapoint.id)}
            sx={{
              backgroundColor: "#ffedee",
              color: "red",
              "&:hover": {
                backgroundColor: "#ffedee",
                color: "red",
                fontSize: "10px",
                cursor: "pointer",
              },
            }}
          >
            <RemoveOutlinedIcon style={{ fontSize: "18px" }} />
          </IconButton>
        </div>
        
      )}
      </div>
    </div>
  );
};

export default DataPointInput;
